import React from "react";
import { ReactComponent as Info } from "../../../assets/icons/info.svg";
import {
  IconButton,
  Tooltip,
  Box,
  Typography,
  List,
  ListItem,
} from "@mui/material";
import { shortenString } from "../../../Constant/helper";
import { converTime } from "../CommonComponents/Common";
import { commonStyles } from "../../../assets/MUIStyles/commonStyles";

const CallHistoryPopover = ({ hasRestrictedCallHistoryAccess, callData }) => {
  return (
    <Tooltip
      slotProps={{
        tooltip: {
          sx: commonStyles.popoverCard.mainContainer,
        },
      }}
      title={
        <Box sx={{ width: 270 }}>
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            sx={{
              p: 1.5,
              borderBottom: "1px solid #e0e0e0",
              bgcolor: "#f5f5f5",
            }}
          >
            Call Details
          </Typography>
          <Box sx={{ p: 1.5 }}>
            <List dense disablePadding sx={{ m: 0 }}>
              {hasRestrictedCallHistoryAccess && (
                <>
                  <ListItem disablePadding sx={{ mb: 1 }}>
                    <Typography variant="body2">
                      <strong>Project Name: </strong>
                      {shortenString(callData?.projectName, 15)}
                    </Typography>
                  </ListItem>
                  <ListItem disablePadding sx={{ mb: 1 }}>
                    <Typography variant="body2">
                      <strong>Campaign Name: </strong>
                      {shortenString(callData?.campaignName, 15)}
                    </Typography>
                  </ListItem>
                  <ListItem disablePadding sx={{ mb: 1 }}>
                    <Typography variant="body2">
                      <strong>Campaign Run Time: </strong>
                      {converTime(callData?.createdAt)}
                    </Typography>
                  </ListItem>
                </>
              )}
              <ListItem disablePadding sx={{ mb: 0 }}>
                <Typography variant="body2">
                  <strong>Call Time: </strong>
                  {converTime(callData?.campaignRunDetails?.createdAt)}
                </Typography>
              </ListItem>
            </List>
          </Box>
        </Box>
      }
      placement="left"
      arrow
      enterDelay={300}
      leaveDelay={200}
    >
      <IconButton>
        <Info title="Info" />
      </IconButton>
    </Tooltip>
  );
};

export default CallHistoryPopover;
